import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { IdCard } from "lucide-react";

export default function MasterTechnicians() {
  return (
    <MasterDataPage
      title="Technicians"
      subtitle="Calibration techs — certifications, skills, hourly rates"
      entity="technicians"
      testId="techs"
      icon={IdCard}
      defaultForm={{
        name: "", email: "", phone: "", role: "technician", hourly_rate: 35, active: true, notes: "",
      }}
      fields={[
        { key: "name", label: "Full Name", required: true, span: 2 },
        { key: "email", label: "Email", type: "email" },
        { key: "phone", label: "Phone" },
        { key: "role", label: "Role", type: "select", options: ["technician", "lead", "supervisor"] },
        { key: "hourly_rate", label: "Hourly Rate ($)", type: "number" },
        { key: "active", label: "Active", type: "checkbox", checkboxLabel: "Currently on staff" },
        { key: "notes", label: "Notes (certs, skills)", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Name" },
        { key: "role", label: "Role" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "hourly_rate", label: "Rate", render: (r) => r.hourly_rate ? `$${r.hourly_rate}/h` : "—" },
        { key: "active", label: "Status", render: (r) => r.active ? "🟢 Active" : "⚪ Inactive" },
      ]}
    />
  );
}
